import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => { logout(); nav("/"); };

  return (
    <nav className="sticky top-0 z-50 border-b border-zinc-800 bg-black/70 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-10 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-2 h-2 bg-red-600" />
          <span className="font-display text-xl tracking-tight uppercase">Asylum<span className="text-red-600">.</span></span>
        </Link>
        <div className="hidden md:flex items-center gap-8 text-xs tracking-[0.2em] uppercase">
          <Link to="/pricing" className="hover:text-red-500 transition-colors" data-testid="nav-pricing">Pricing</Link>
          <Link to="/#platforms" className="hover:text-red-500 transition-colors" data-testid="nav-platforms">Platforms</Link>
          <Link to="/how-it-works" className="hover:text-red-500 transition-colors" data-testid="nav-how">How It Works</Link>
          <Link to="/compare" className="hover:text-red-500 transition-colors" data-testid="nav-compare">Compare</Link>
          {user ? (
            <>
              <Link to="/dashboard" className="hover:text-red-500 transition-colors" data-testid="nav-dashboard">Dashboard</Link>
              {user.role === "admin" && <Link to="/admin" className="hover:text-red-500 transition-colors" data-testid="nav-admin">Admin</Link>}
              <button onClick={doLogout} className="text-zinc-400 hover:text-red-500 transition-colors" data-testid="nav-logout">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="hover:text-red-500 transition-colors" data-testid="nav-login">Login</Link>
              <Link to="/signup" className="bg-red-600 text-white px-4 py-2 btn-brutal btn-brutal-red" data-testid="nav-signup">Sign Up</Link>
            </>
          )}
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-zinc-800 px-6 py-4 flex flex-col gap-3 text-sm">
          <Link to="/pricing" onClick={() => setOpen(false)}>Pricing</Link>
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)}>Admin</Link>}
              <button onClick={doLogout} className="text-left">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
              <Link to="/signup" onClick={() => setOpen(false)}>Sign Up</Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}
